import {constantsTypes} from '../reduxConstants';

export const setLogindataValue = (value)=>{
    return{
        type:constantsTypes.LOGIN_DATA,
        payload:value
    }
}